(function () {
  var STORAGE_KEY = 'gwong_recently_viewed';
  var MAX_ITEMS = 8;

  function readCurrentProduct() {
    var el = document.querySelector('[data-current-product]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function readStored() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function writeStored(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
      /* ignore quota / private mode */
    }
  }

  function upsertCurrent(items, current) {
    if (!current || !current.handle) return items;
    var next = items.filter(function (item) {
      return item.handle !== current.handle;
    });
    next.unshift({
      handle: current.handle,
      title: current.title,
      url: current.url,
      image: current.image,
      price: current.price
    });
    return next.slice(0, MAX_ITEMS);
  }

  function renderCard(item) {
    var article = document.createElement('article');
    article.className = 'cb-product-card cb-pdp-recent__card';
    article.innerHTML =
      '<a href="' +
      item.url +
      '" class="cb-product-card__link">' +
      '<div class="cb-product-card__media">' +
      (item.image
        ? '<img class="cb-product-card__img" src="' +
          item.image +
          '" alt="" width="400" height="400" loading="lazy">'
        : '<div class="cb-product-card__img cb-product-card__img--placeholder"></div>') +
      '</div>' +
      '<div class="cb-product-card__body">' +
      '<h3 class="cb-product-card__title">' +
      item.title +
      '</h3>' +
      (item.price ? '<p class="cb-product-card__price">' + item.price + '</p>' : '') +
      '</div>' +
      '</a>';
    return article;
  }

  function init() {
    var section = document.querySelector('[data-pdp-recently-viewed]');
    var track = document.querySelector('[data-recently-viewed-track]');
    if (!section || !track) return;

    var current = readCurrentProduct();
    var stored = readStored();
    stored = upsertCurrent(stored, current);
    writeStored(stored);

    var limit = 4;
    var limitAttr = section.getAttribute('data-limit');
    if (limitAttr) {
      var parsed = parseInt(limitAttr, 10);
      if (!isNaN(parsed)) limit = parsed;
    }

    var visible = stored.filter(function (item) {
      return !current || item.handle !== current.handle;
    }).slice(0, limit);

    if (!visible.length) {
      section.hidden = true;
      return;
    }

    track.innerHTML = '';
    visible.forEach(function (item) {
      track.appendChild(renderCard(item));
    });
    section.hidden = false;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
